import type { IKpiRepository, KpiValueCreateInput } from '../repositories/IKpiRepository.js';
import type { KpiValueEntity } from '../entities/KpiEntity.js';

export function createCreateKpiValueUseCase({ kpiRepository }: { kpiRepository: IKpiRepository }) {
  return (input: KpiValueCreateInput): Promise<KpiValueEntity> =>
    kpiRepository.createKpiValue(input);
}
